import { render, staticRenderFns } from "./ECommerceHeZhu.vue?vue&type=template&id=f8b71ca0&"
import script from "./ECommerceHeZhu.vue?vue&type=script&lang=js&"
export * from "./ECommerceHeZhu.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceHeZhu.vue?vue&type=style&index=0&id=f8b71ca0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports